import type { RequirementsItem } from "./types";

export const BATCH_SIZE = 5;
export const BATCH_DELAY_MS = 1500;

export const ALLOWED_HEADERS = [
  'name', 'handle', 'platform', 'followers_count', 'engagement_rate',
  'location', 'email', 'phone', 'tags'
];

export const SAMPLE_CSV_DATA = `name,handle,platform,followers_count,engagement_rate,location,email,phone,tags
John Doe,johndoe,instagram,50K,3.5,Mumbai,john@example.com,+919876543210,Fashion|Lifestyle
Jane Smith,janesmith,youtube,2.5M,4.2,Delhi,jane@example.com,+919876543211,Tech|Education
Mike Johnson,mikej,instagram,100K,2.8,Bangalore,mike@example.com,+919876543212,Fitness`;

export const REQUIREMENTS_LIST: RequirementsItem[] = [
  { label: "Required", field: "handle", desc: "Instagram handle (without @)" },
  { label: "Optional", field: "name", desc: "Full name of influencer" },
  { label: "Optional", field: "platform", desc: "Platform (e.g., Instagram, YouTube)" },
  { label: "Optional", field: "followers_count", desc: "Total number of followers" },
  { label: "Optional", field: "engagement_rate", desc: "Engagement rate (%)" },
  { label: "Optional", field: "location", desc: "Location or country" },
  { label: "Optional", field: "email", desc: "Contact email" },
  { label: "Optional", field: "tags", desc: "Comma separated tags" }
];
